<div *ngIf="adminService.isAuthenticated()" fxLayout="column" fxFill fxLayoutAlign="start stretch" class="feedbacks-container">
  
  <div fxLayout="column" fxLayoutAlign="space-between stretch" class="feedback-analysis-card-container">
    <mat-card class="feedback-analysis-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Feedback Analysis</mat-card-title>
        <mat-button-toggle-group name="feedbackAnalysisFrequencyPeriod" aria-label="Feedback Analysis Period" [(value)]="feedbackAnalysisFrequencyPeriod" (change)="feedbackAnalysisFrequencyPeriod = $event.value; updateFeedbackAnalysisChart()">
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="isFeedbackAnalysisChartLoading" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div *ngIf="isFeedbackAnalysisChartFailed" fxLayout="row" fxLayoutAlign="center center" fxFill>
          <div style="color: #f44336;">Failed to load</div>
        </div>
        <div class="stacked-horizontal-chart-container">
          <div>Was the tool helpful?</div>
          <div id="wasHelpful-freq-chart-svg"></div>
        </div>
        <div class="stacked-horizontal-chart-container">
          <div>Did you like the user interface?</div>
          <div id="uiIsGood-freq-chart-svg"></div>
        </div>
        <div class="stacked-horizontal-chart-container">
          <div>Would you use this tool?</div>
          <div id="iWillUseIt-freq-chart-svg"></div>
        </div>
        <div class="stacked-horizontal-chart-container">
          <div>Had major problems?</div>
          <div id="majorProblems-freq-chart-svg"></div>
        </div>

        <div class="feedback-analytics-legend" fxLayout="row" fxLayoutAlign="space-around center">
          <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
            <div class="legend-item-box legend-item-strongly-agree"></div>
            <div>Strongly Agree</div>
          </div>
          <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
            <div class="legend-item-box legend-item-agree"></div>
            <div>Agree</div>
          </div>
          <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
            <div class="legend-item-box legend-item-neutral"></div>
            <div>Neutral</div>
          </div>
          <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
            <div class="legend-item-box legend-item-disagree"></div>
            <div>Disagree</div>
          </div>
          <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
            <div class="legend-item-box legend-item-strongly-disagree"></div>
            <div>Strongly disagree</div>
          </div>
          <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
            <div class="legend-item-box legend-item-yes"></div>
            <div>Yes</div>
          </div>
          <div class="legend-item" fxLayout="row" fxLayoutAlign=" center">
            <div class="legend-item-box legend-item-no"></div>
            <div>No</div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>
  </div>

  <div fxLayout="column" fxLayoutAlign="space-between stretch" class="feedbacks-card-container">
    <mat-card class="feedbacks-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>Feedbacks</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutAlign="start start">
        <mat-card *ngFor="let feedback of adminService.feedback" class="feedback-card">
          <mat-card-header>
            <mat-card-title>{{feedback.time | date: 'dd.MM.yyyy HH:mm'}}</mat-card-title>
            <mat-card-subtitle>{{feedback._id}}</mat-card-subtitle>
          </mat-card-header>
        
          <mat-card-content>
        
            <mat-list>
              <mat-list-item>
                <mat-icon mat-list-icon>help</mat-icon>
                <div mat-line><span class="feedbackEntry">Tool was helpful: <span class="answer">{{this.LABELS[feedback.wasHelpful-1]}}</span></span></div>
                <div class="allowWrap" mat-line>
                  <mat-progress-bar mode="determinate" value="{{(5-feedback.wasHelpful)/4*100}}"></mat-progress-bar>
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon mat-list-icon>design_services</mat-icon>
                <div mat-line><span class="feedbackEntry">Interface was good: <span class="answer">{{this.LABELS[feedback.uiIsGood-1]}}</span></span></div>
                <div class="allowWrap" mat-line>
                  <mat-progress-bar mode="determinate" value="{{(5-feedback.uiIsGood)/4*100}}"></mat-progress-bar>
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon mat-list-icon>mouse</mat-icon>
                <div mat-line>
                  <span class="feedbackEntry">Would use this tool: <div class="answer entryWithIcon">{{feedback.iWillUseIt? 'Yes' : 'No'}}
                  <mat-icon *ngIf="feedback.iWillUseIt">check_circle_outline</mat-icon>
                  <mat-icon *ngIf="!feedback.iWillUseIt">remove_circle_outline</mat-icon>
                </div>
                </span>
                </div>
                <div class="allowWrap" mat-line>
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon mat-list-icon>report_problem</mat-icon>
                <div mat-line>
                  <span class="feedbackEntry">Had major problems: <div class="answer entryWithIcon">{{feedback.majorProblems? 'Yes' : 'No'}}
                  <mat-icon *ngIf="feedback.majorProblems" color="warn">report_problem</mat-icon>
                  <mat-icon *ngIf="!feedback.majorProblems">check_circle_outline</mat-icon>
                  </div>
              </span>
                </div>
                <div class="allowWrap" mat-line>
                </div>
              </mat-list-item>
              <div *ngIf="feedback.uploaded_files && feedback.uploaded_files.length > 0">
              <mat-list-item>
                <mat-icon mat-list-icon>attach_file</mat-icon>
                <div mat-line>
                  <span class="feedbackEntry">Files:
              </span>
                </div>
              </mat-list-item>
              <div>
                <mat-list class="fileList">
                  <mat-list-item *ngFor="let file of feedback.uploaded_files">
                    <mat-icon mat-list-icon title="{{file.mimetype}} ({{file.size}}B)">file_copy</mat-icon>
                    {{file.originalname}}
                    <a href="{{adminService.getFileURL(feedback._id,file.filename)}}" download="{{file.originalname}}" class="fileDownloadButton">Download</a>
                  </mat-list-item>
                </mat-list>
              </div>
            </div>
              <mat-list-item>
                <mat-icon mat-list-icon>text_fields</mat-icon>
                <div mat-line>
                  <span class="feedbackEntry">Comment:
              </span>
                </div>
              </mat-list-item>
              <div class="feedbackText">
                <p>
                  {{feedback.suggestions}}
                </p>
              </div>
            </mat-list>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button color="warn" (click)="this.adminService.deleteFeedback(feedback._id)">Delete</button>
            <button mat-button color="primary" (click)="this.logToConsole(feedback)">Log JSON</button>
          </mat-card-actions>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>